import { createContext, useContext, type ReactNode } from 'react'

/**
 * Interruptor dos rótulos HTML ancorados na cena (`Rotulo3D`).
 *
 * Ligado por padrão: nas oficinas de zonas o rótulo do anel é a informação
 * principal, não um enfeite. Uma cena pode desligar quando eles atrapalham.
 */
const ContextoRotulos = createContext(true)

export function ProvedorRotulos({ visiveis, children }: { visiveis: boolean; children: ReactNode }) {
  return <ContextoRotulos.Provider value={visiveis}>{children}</ContextoRotulos.Provider>
}

export function useRotulosCenaVisiveis(): boolean {
  return useContext(ContextoRotulos)
}
